module.exports = __webpack_public_path__ + "static/media/footer-app-screen.d8643947.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer-app-screen.png
// module id = 738
// module chunks = 0